import { render } from "./IconDefibrillator.vue?vue&type=template&id=e66f8cf0&scoped=true"
const script = {}

import "./IconDefibrillator.vue?vue&type=style&index=0&id=e66f8cf0&scoped=true&lang=css"

import exportComponent from "/builds/lindner/lindner-factorytour-frontend-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e66f8cf0"]])

export default __exports__